export default __webpack_public_path__ + "static/media/leduranBack.22f36727.png";